import cn from 'classnames';
import * as React from 'react';
import { useRef } from 'react';

import { SeoLink } from './SeoLink';
import * as style from './style.css';
import { ISeoTabLink } from '../../../common/types/seoTabsLinks';

interface IShortListProps {
  links: ISeoTabLink[];
}

export const SeoLinksList = ({ links }: IShortListProps) => {
  const ref: React.RefObject<HTMLDivElement> = useRef(null);

  return (
    <div className={style['links-block']} ref={ref}>
      <div className={cn(style['links'], style['links--expanded'])}>
        {links.map((link, index) => (
          <SeoLink link={link} key={index} />
        ))}
        {links.map((link, index) => (
          <SeoLink link={link} key={`rest_${index}`} />
        ))}
      </div>
    </div>
  );
};
